/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckUserBasic } from './deck-user-basic';

export interface DeckLogEntry {
  readonly user: DeckUserBasic;
  readonly change_message: string;
  readonly action_time: string;
}
